﻿$.fn.dxCtrlEmailPrevisualisationMobile = function custom_dxCtrlEmailPrevisualisationMobile(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlemailprevisualisationmobile dx-ctrl");
        this.createInstance(new cdxCtrlEmailPrevisualisationMobile(this, option));
    }
    return this;
}

window.cdxCtrlEmailPrevisualisationMobile = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var $DivMobile = $("<div style='width:100%;height:100%;display:flex;justify-content:center;align-items:center;'/>").appendTo(container)
        var $DivMobileInterne = $("<div style='width:100%;height:100%;max-height:750px;max-width:380px;position:relative;'/>").appendTo($DivMobile)
        var $DivTop = $("<div style='position:absolute;top:0;right:0;height:70px;width:100%;background-color:black;border-radius:30px 30px 0 0;display:flex;justify-content:center;align-items:center;'/>").appendTo($DivMobileInterne)
        $("<div style='width:25px;height:8px;background-color:white;border-radius:5px;'/>").appendTo($DivTop)
        var $DivLeft = $("<div style='position:absolute;top:70px;right:0;height:calc(100% - 160px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        var $DivRight = $("<div style='position:absolute;top:70px;left:0;height:calc(100% - 160px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        var $DivBottom = $("<div style='position:absolute;bottom:30px;right:0;height:90px;width:100%;background-color:black;border-radius:0 0 30px 30px;display:flex;justify-content:center;align-items:center;margin-bottom:5px;'/>").appendTo($DivMobileInterne)
        $DivDetail = $("<div style='position:absolute;bottom:0;text-align:center;opacity:0.3;font-size:90%;width:100%;'></div>").appendTo($DivMobileInterne)
        var $DivRond = $("<div style='width:40px;height:40px;background-color:white;border-radius:50%;'/>").appendTo($DivBottom)

        var $DivContainer = $("<div style='position:absolute;top:70px;left:20px;width:calc(100% - 40px);height:calc(100% - 190px);'/>").appendTo($DivMobileInterne)


        if (option.contentTemplate) {
            var dxVisu = option.contentTemplate($DivContainer)
        } else {
            var dxScroll = $("<div/>").appendTo($DivContainer).dxScrollView({}).dxScrollView("instance")
            dxScroll.element().find(".dx-scrollview-content").css("height", dxScroll.element().innerHeight() + "px")
            resizeObserver.mAdd(dxScroll.element(), function () { dxScroll.element().find(".dx-scrollview-content").css("height", dxScroll.element().innerHeight() + "px") })
            if (option.contentTemplate) {
                dxVisu = option.contentTemplate(dxScroll.content())
            } else {
                var dxVisu = $("<div style='position:absolute;display:none;width:100%;height:100%;'/>").appendTo(dxScroll.content()).dxCtrlIframeResize({
                    disabled: (typeof option.disabled ? option.disabled : true),
                    src: option.src,
                    deltaX: 0,
                    zoom: option.zoom,
                    onContentReady: function (component) {
                        component.element().find("iframe").css("min-height", "100%")
                        if (option.onContentReady) option.onContentReady()
                    }
                }).dxCtrlIframeResize("instance")
            }

        }


        dxVisu.element().slideDown(500)

    }

    this.element = function () { return container }

    mConstruit();
}